export default __webpack_public_path__ + "static/profile-e4e0ec78c6fc2375437c9325a8857811.png";